import React from 'react';
import Column from '../../column/index';
import Grid from './grid';

const Buttons = ({
  // id,
  columnWidth,
  align,
  justify,
  order,
  buttons = [],
  calendarEvents = [],
  offset,
}) => ((buttons?.length === 0 && calendarEvents?.length === 0) ? null : (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    order={order}
    offset={offset}
  >
    <Grid
      justify={justify}
      buttons={buttons}
      calendarEvents={calendarEvents}
    />
  </Column>
));

export default Buttons;
